import cx from 'classnames';
import * as React from 'react';

import LoadingIndicator from 'components/LoadingIndicator';

import './styles/Table.scss';

export type Props = {
  actionsColumn?: boolean;
  actionsColumnShowOnHover?: boolean;
  // row between head & body containing actions
  actionsRow?: React.ReactNode;
  // must render `tbody`
  children: React.ReactNode;
  className?: string;
  equalWidthColumns?: boolean;
  fixedHeader?: boolean;
  // must render `tr`
  head?: React.ReactNode;
  loading?: boolean;
  stripes?: boolean;
  'data-testid'?: string;
};

export default function Table({
  actionsColumn,
  actionsColumnShowOnHover,
  actionsRow,
  children,
  className,
  equalWidthColumns,
  fixedHeader,
  head,
  loading,
  stripes,
  ...props
}: Props) {
  const loadingRow = (
    <tbody>
      <tr>
        <td colSpan={99}>
          <LoadingIndicator
            align="center"
            // 2 rows
            height={84}
            size="small"
          />
        </td>
      </tr>
    </tbody>
  );

  return (
    <table
      className={cx(
        'Table',
        actionsColumn && 'Table--actionsColumn',
        actionsColumnShowOnHover && 'Table--actionsColumn--hidden',
        equalWidthColumns && 'Table--equalWidthColumns',
        fixedHeader && 'Table--fixedHeader',
        stripes && 'Table--stripes',
        className
      )}
      data-testid={props['data-testid']}
    >
      {head && (
        <thead>
          {head}
          {actionsRow && (
            <tr className="Table-actionsRow">
              <th colSpan={99} className="Table-actionsRow-cell">
                {actionsRow}
              </th>
            </tr>
          )}
        </thead>
      )}
      {children}
      {loading && loadingRow}
    </table>
  );
}
